import { ca } from '@cian/analytics';

export function trackChoseRealtorClick() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'DealSaleCcPromo',
    action: 'Click',
    label: 'choose_rieltor',
  });
}
